import { Card, Form, Input, Select } from 'antd';
import { CoursesIconComponent } from 'assets/icons/courses';
import { CreateLayout } from 'components/layout/layout/CreateLayout';
import {
  IGraduateDiscipline,
  IGraduateDisciplineModules
} from 'interfaces/graduate_disciplines';
import { PageHeader } from 'components/professor_area/PageHeader';
import { getTenant } from 'services/tenants';
import { useCallback, useMemo } from 'react';
import { useForm, useSelect } from '@refinedev/antd';

export const GraduateDisciplineCreate = () => {
  const { name } = getTenant();
  const { form, onFinish, formProps, saveButtonProps } =
    useForm<IGraduateDiscipline>({
      redirect: 'edit',
      successNotification: () => ({
        type: 'success',
        description: 'Sucesso!',
        message: 'Disciplina cadastrada com sucesso'
      }),
      errorNotification: error => {
        if (
          error?.message === 'Validation failed: Code has already been taken'
        ) {
          return {
            type: 'error',
            description: 'Ops!',
            message: 'Código da disciplina duplicado.'
          };
        }

        return {
          type: 'error',
          description: 'Ops!',
          message: 'Não foi possivel cadastrar a disciplina.'
        };
      }
    });
  const { selectProps: modulesSelectProps, queryResult } =
    useSelect<IGraduateDisciplineModules>({
      resource: 'graduate_modules',

      onSearch: value => [
        {
          field: 'filter[name]',
          operator: 'eq',
          value
        }
      ],

      pagination: {
        mode: 'server'
      }
    });

  const modules = useMemo(() => {
    return queryResult?.data?.data.map(module => {
      const {
        external_reference,
        name,
        course_external_reference,
        course_name,
        id
      } = module;

      const codModuleExternal = external_reference
        ? `${external_reference} - `
        : '';

      const codCourseExternal = course_external_reference
        ? `${course_external_reference} - `
        : '';

      const label = `Módulo: ${codModuleExternal} ${name} | Curso: ${codCourseExternal} ${course_name}`;

      return {
        label,
        value: id
      };
    });
  }, [queryResult?.data?.data]);

  const handleCreate = useCallback(() => {
    onFinish({
      ...form.getFieldsValue(),
      code: name?.slice(0, 3)?.toUpperCase() + form.getFieldValue('code')
    }).catch(error => {
      // eslint-disable-next-line no-console
      console.log(error);
    });
  }, [form, name, onFinish]);

  return (
    <CreateLayout saveButtonProps={saveButtonProps}>
      <PageHeader title="Criar disciplina" icon={CoursesIconComponent} />

      <Card>
        <Form {...formProps} onFinish={handleCreate} layout="vertical">
          <Form.Item
            label="Código da disciplina"
            name="code"
            rules={[
              {
                required: true
              },
              {
                pattern: new RegExp(/^\d{4}$/),
                message: 'Insira um numero válido de 4 digitos'
              }
            ]}
          >
            <Input
              className="max-w-[110px]"
              maxLength={4}
              addonBefore={name.slice(0, 3).toUpperCase()}
            />
          </Form.Item>
          <Form.Item
            label="Nome"
            name="name"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Duração (minutos)"
            name="duration_in_minutes"
            rules={[
              {
                required: true
              }
            ]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item label="Modulos" name="module_ids">
            <Select {...modulesSelectProps} mode="multiple" options={modules} />
          </Form.Item>
        </Form>
      </Card>
    </CreateLayout>
  );
};
